// extracted by mini-css-extract-plugin
export default {"content":"AuthStatus_content__hygDj","userWrapper":"AuthStatus_userWrapper__EIicB","user":"AuthStatus_user__MlJyf"};